import HtmlElement from './HtmlElement';
import {$body} from '../Constants';

/**
 * Text Rotation
 */
class TextAnimation extends HtmlElement {
	onReady() {
		this.$rotationChanging = this.$element.find('.text-animation-changing');
		this.$changingElements = this.$rotationChanging.find('> li');

		this.amount = this.$changingElements.length;
		this.index = 0;
		this.interval = null;
		this.intervalTime = 3000;

		this.setRotationChangingHeight();
		this.startChanging();
	}

	setRotationChangingHeight() {
		let widths = [],
			heights = [];

		this.$changingElements.each(function() {
			widths.push($(this).width());
			heights.push($(this).outerHeight());
		});

		this.$rotationChanging.css({
			'width': Math.max(...widths),
			'height': Math.max(...heights)
		});
	}

	startChanging() {
		this.$changingElements.eq(this.index).addClass('visible');

		this.interval = setInterval(() => {
			this.$changingElements.eq(this.index).removeClass('visible');

			let nextIndex = this.getNextElementIndex();
			this.$changingElements.eq(nextIndex).addClass('visible');
			this.index = nextIndex;
		}, this.intervalTime);
	}

	getNextElementIndex() {
		let next = 0;

		if(this.index + 1 < this.amount) {
			next = this.index + 1;
		}

		return next;
	}
}

let allTextAnimations = [];

$body.find('.text-animation').each(function() {
	allTextAnimations.push(new TextAnimation($(this)));
});

export default allTextAnimations;
